import React from 'react'

const RedesSociales = () => {
    let redes = [
                { imagen: '/images/banyan-tree.jpg', enlace: "https://banyantree.gmd.mx/"},
                { imagen: '/images/marina-cabo-marques.jpg', enlace: "https://marinacabomarques.gmd.mx/"},
                { imagen: '/images/los-riscos-cabo-marques.jpg', enlace: "https://cabomarques.gmd.mx/proyectos/los-riscos/"},
                { imagen: '/images/gmd-grupo-mexicano-de-desarrolllo.jpg', enlace: "https://www.gmd.mx/"},
                { imagen: '/images/gmd-resorts.jpg', enlace: "https://www.gmd.mx/gmd-resorts.html"},
            ] 

    return (
        <div className="sitios-relacionados">
            <div className="imagenes">
                {
                    redes.map((red, index) => (
                        <a href={red.enlace} key={index} rel="noreferrer" target="_blank">
                            <img src={red.imagen} alt="" />
                        </a>
                    ))
                } 
            </div>
            <div className="aclaracion-imagenes">
                <p>
                    *Imágenes con fines ilustrativos, características pueden cambiar sin previo aviso.
                </p>
            </div>
        </div>
    )
}

export default RedesSociales